import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';
import { handleResponseError } from '../../../utils/helpers/network-error';

export const createProject = createAsyncThunk('projects.createProject', async ({
  formData, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { data: { newProject, message }} = await api.projects.create(formData);
    onSuccess(message);
    return newProject;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});

export const updateProject = createAsyncThunk('projects.updateProject', async ({
  formData, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { _id, ...rest } = formData;

    const formDataWithoutEmptyFields = Object.keys(rest).reduce((acc, key) => {
      if (rest[key]) {
        acc[key] = rest[key];
      }
      return acc;
    }, {});

    const { data: { updatedProject, message }} = await api.projects.update(_id, formDataWithoutEmptyFields);
    onSuccess(message);
    return updatedProject;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});

export const getProjects = createAsyncThunk('projects.getProjects', async ({
  page, limit, search
}, { rejectWithValue }) => {
  try {
    const queryParams = {
      page,
      limit,
    };

    if (search && search.trim().length > 0) {
      queryParams.search = search.trim();
    }

    const { data: { projects, totalDocs }} = await api.projects.getProjects(queryParams);
    
    return {
      projects,
      totalDocs,
    };
  } catch (error) {
    handleResponseError(error);
    return rejectWithValue();
  }
});

export const deleteProjects = createAsyncThunk('projects.deleteProjects', async ({
  ids, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { data: { message }} = await api.projects.deleteProjects(ids);
    onSuccess(message);
    return ids;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});
